import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { BbitWebsiteService, I18nPipe } from '@bbitgmbh/website.sdk';
import { NgIcon } from '@ng-icons/core';
import { BehaviorSubject } from 'rxjs';
import { LoadingComponent } from '../../../helper/loading/loading.component';
import {
  IBbitPlaceBookingCancellationOverlayData,
  PlaceBookingCancellationOverlayRef,
} from './place-booking-cancellation-overlay.ref';

@Component({
  selector: 'app-place-booking-cancellation-overlay',
  templateUrl: './place-booking-cancellation-overlay.component.html',
  styleUrl: './place-booking-cancellation-overlay.component.scss',
  imports: [NgIcon, LoadingComponent, AsyncPipe, I18nPipe],
})
export class PlaceBookingCancellationOverlayComponent {
  public data!: IBbitPlaceBookingCancellationOverlayData;
  public displayType = new BehaviorSubject<'book' | 'success' | 'error' | 'loading'>('book');

  constructor(
    private _overlayRef: PlaceBookingCancellationOverlayRef,
    private _website: BbitWebsiteService,
  ) {
    this.data = this._overlayRef.getData();
  }

  close(reload = false) {
    this._overlayRef.close(reload);
  }

  async cancelBooking(): Promise<void> {
    this.displayType.next('loading');

    try {
      const response = await fetch(`${this._website.getBlApiUrl()}/placeBooking/cancel`, {
        method: 'POST',
        headers: {
          Authorization: `${this._website.getAccessToken()}`,
        },
        body: JSON.stringify({
          booking: this.data.event._id,
        }),
      });
      if (!response.ok) {
        throw new Error('Cancellation failed');
      }
      this.displayType.next('success');
    } catch (err) {
      this.displayType.next('error');
      console.error(err);
    }
  }
}
